<template>
  <BasicModal
    wrap-class-name="standard_excel-upload-modal"
    title="上传"
    v-bind="$attrs"
    destroyOnClose
    :default-fullscreen="false"
    @register="register"
    @ok="handleOk"
    :min-height="200"
    :width="400"
    ok-text="确定"
    cancel-text="取消"
  >
    <template v-if="true">
      <a-upload-dragger
        accept=".xls*"
        name="file"
        v-model:fileList="fileList"
        :multiple="true"
        :beforeUpload="beforeUpload"
        class="upload-content"
      >
        <p class="ant-upload-drag-icon">
          <inbox-outlined />
        </p>
        <p class="ant-upload-text">将文件拖至此处,或点击上传</p>
      </a-upload-dragger>
      <div class="template" v-if="$props.templateUrl"><a :href="$props.templateUrl">点击下载模板</a></div>
    </template>
  </BasicModal>
</template>

<script lang="ts">
  import { defineComponent, ref } from 'vue';
  import { BasicModal, useModalInner } from '/@/components/Modal';
  import { Upload, message } from 'ant-design-vue';
  import { UploadFileService } from '/@/utils/oss/upload_service';
import { propTypes } from '/@/utils/propTypes';

  export default defineComponent({
    components: { BasicModal },
    emits: ['commit', 'register'],
    props: {
      templateUrl: propTypes.string.def(''),
    },
    setup(props, { emit }) {
      const fileList = ref([]);
      const [register, { closeModal }] = useModalInner(async () => {});
      const handleOk = async () => {
        const ossRes = await Promise.all(
          fileList.value.map((file: any) =>
            UploadFileService.uploadFile2(file.originFileObj ?? file)
          )
        );
        emit('commit', window.ENV_CONFIG.ossPrefix + ossRes[0].fileAddress);
        closeModal();
        fileList.value = [];
      };

      const beforeUpload = (file) => {
        const isXLSX =
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isXLSX) {
          message.error(`${file.name} is not a xlsx file`);
        }
        return isXLSX;
      };

      return {
        handleOk,
        beforeUpload,
        fileList,
        register,
        props,
      };
    },
  });
</script>

<style lang="less" scoped>
  .standard_excel-upload-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    .template {
      position: absolute;
      bottom: 0px;
      color: #1677ff;
      text-decoration: underline;
    }
  }
</style>
